import { render } from "./SkeletonProductItem.vue?vue&type=template&id=65de5079&scoped=true"
import script from "./SkeletonProductItem.vue?vue&type=script&lang=js"
export * from "./SkeletonProductItem.vue?vue&type=script&lang=js"

import "./SkeletonProductItem.vue?vue&type=style&index=0&id=65de5079&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65de5079"]])

export default __exports__